import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = (theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    margin: theme.spacing(0, 0, 2, 0),
  },
  rootHidden: {
    display: 'none',
  },
  valuesContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
});

const SubscriptionPaymentSummaryItem = ({
  className,
  classes,
  label: sectionLabel,
  name: sectionName,
  lineItems,
  ValueTypographyProps,
  LabelTypographyProps,
}) => {
  return (
    <Box
      className={classNames(classes.root, className, {
        [classes.rootHidden]: lineItems.length === 0,
      })}
      test={'subscription-payment-summary-item-section-root'}
    >
      <Typography
        weight={'bold'}
        test={`subscription-payment-summary-item-section-${sectionName}`}
        {...LabelTypographyProps}
      >
        {sectionLabel}
      </Typography>
      <div className={classes.valuesContainer}>
        {lineItems && lineItems.map((lineItem) => {
          const { name, label } = lineItem;

          return (
            <Typography
              key={name}
              weight={'bold'}
              align={'right'}
              test={`subscription-payment-summary-section-${sectionName}-${name}`}
              {...ValueTypographyProps}
            >
              {label}
            </Typography>
          );
        })}
      </div>
    </Box>
  );
};

SubscriptionPaymentSummaryItem.defaultProps = {
  className: '',
  LabelTypographyProps: {
    variant: 'body1',
    color: 'primaryGray',
  },
  ValueTypographyProps: {
    variant: 'body1',
    color: 'primary',
  },
};

SubscriptionPaymentSummaryItem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  ValueTypographyProps: PropTypes.object,
  LabelTypographyProps: PropTypes.object,
};

export default withStyles(styles)(SubscriptionPaymentSummaryItem);
